export const fmtMoney = (v, showCurrency = true) => {
  if (v === null || v === undefined || isNaN(v)) return showCurrency ? "AED 0.00" : "0.00";
  const s = Number(v).toLocaleString("en-AE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return showCurrency ? `AED ${s}` : s;
};

export const fmtNum = (v, digits = 2) => {
  if (v === null || v === undefined || isNaN(v)) return "0";
  return Number(v).toLocaleString("en-AE", { minimumFractionDigits: 0, maximumFractionDigits: digits });
};

export const fmtPct = (v, digits = 2) => {
  if (v === null || v === undefined || isNaN(v)) return "0.00%";
  return `${Number(v).toFixed(digits)}%`;
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};
